/**
 * @Author: wuyang
 * @Date: 2024/1/4
 * @Description: ""
 */
import { QueryClient, QueryClientConfig } from '@tanstack/react-query'

interface IBaseQueryClientProps extends QueryClientConfig {}

export class BaseQueryClient extends QueryClient {
	// eslint-disable-next-line
	constructor(props: IBaseQueryClientProps) {
		super(props)
	}
}
